import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ICreateDocumentFieldForm} from '../recipientfields/recipientfields.component';
import {IMetadataItemDto, IMetadataListDTO} from './metadata-item.dto';
import { IField } from '../documenttype/document-type-settings-modal/document-type-settings.dto';

export interface IAssignMetadataToDocumentResponse{
    id:number,
    user_id:number,
    workspace_id:number,
    document_type_custom_boxe_id:number,
    meta_data_id:number,
    field_order: number,
    status:boolean
}

@Injectable({
    providedIn: 'root'
})

export class DocumentFieldService {
    
    constructor(private http:HttpClient){}
    /**
     * Fetching document fields with pagination and query strign which used in search bar
     * @param page
     * @param query
     * @param extraParams
     * @returns
     */
    documentfields(page:string|number, query:string, extraParams:string = ''):Observable<IMetadataListDTO | IMetadataItemDto[]>{
        return this.http.get<IMetadataListDTO | IMetadataItemDto[]>(`metadata?page=${page}&q=${query}&${extraParams}`);
    }

    /**
     * Fetching document fields with query strign which used in search bar
     * @param page 
     * @param query 
     * @returns
     */
    getAllDocumentfields(page:string|number, query:string, extraParams:string = ''):Observable<IMetadataItemDto[]>{
        return this.http.get<IMetadataItemDto[]>(`metadata?page=${page}&q=${query}&${extraParams}`);
    }


    /**
     * Creating document field
     * @param formData 
     * @returns 
     */
    createDocumentField(formData:ICreateDocumentFieldForm){
        return this.http.post<ICreateFormFieldMetadataResponse>('metadata', formData);
    }


    /**
     * Update document fields
     * @param formData 
     * @returns 
     */
    updateDocumentField(formData){
        return this.http.put(`metadata/${formData.id}`, formData);
    }

    assignMetadataToDocument(documentTypeId: number,customBoxId:number, metadata_id:number ):Observable<IField>{
        return this.http.post<IField>(`documenttypes/${documentTypeId}/custom-boxes/${customBoxId}`, {
            metadata_id:metadata_id
        });
    }

    /**
     * Deleting document fields
     * @param id
     */
    deleteDocumentFields(id:number){
        return this.http.delete(`metadata/${id}`);
    }

    apiFieldOptions(id:number){
        return this.http.get(`metadata/${id}/field-options`);
    }
}

export interface ICreateFormFieldMetadataResponse{
    meta_data_name: string;
}
